import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/NavBar";
import Home from "./pages/Home";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import OpeningTrainer from "./pages/OpeningTrainer";
import TournamentPage from "./pages/TournamentPage";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogList />} /> {/* This now points to BlogList */}
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/openingtrainer" element={<OpeningTrainer />} />
          <Route path="/tournaments/:tournament" element={<TournamentPage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
